import React, { useEffect, useState } from "react";
import TitlePageTotvs from "../../../components/TitlePageTotvs";
import LoadingSpinner from "../../../components/LoadinSpinner";
import SubmitForm from "../../../components/SubmitForm";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Tabs, Button} from "react-bootstrap";
import SelectComprador from "../../../components/Select/Comprador";
import InputGeral from "../../../components/InputGeral/Index";
import { toast } from "react-toastify";
import { ConsumoAPI_FileUpload } from "../../../../backend/ConsumoAPI";
import { LabelInput } from "../../../components/InputGeral/styles";
import UploadFiles from "../../../components/UploadFiles";
import { Tab } from "bootstrap/dist/js/bootstrap.bundle.min";
import { handleCompradorSCColumn, handleSCCentroCustoCard, handleSCAnexosDecode, handleProdutoSCCard, handleQtdValorSCCard, handleSCPrioridadeCard, handleSCDataEmissaoCard, handleSCDataPrevisaoCard, handleObservacaoInternaCard } from "../../../components/GridCell/Solicitacao"
import { encryptAES, ErroMsg, formatarData, formatDateComponent, optionsStatusSC, RetornaUsuarioLogado, SucessoMsg } from "../../../contents/VariaveisGlobais";
import TrelloBoard from "../../../components/TrelloBoard";
import { handleObservacaoInterna } from "../../../components/GridCell/Solicitacao";
import ResponsiveDataTable from "../../../components/DataTable";
import { usePopUp } from "../../../components/BootBox";
import SelecaoSolicitacaoCompra, { getSelecionados } from "../../../components/SelecaoSolicitacaoCompra";
import SelecaoFornecedores, { getSelecionadosFornecedor } from "../../../components/SelecaoFornecedores";
import Cotacao from "../../../../lib/json/consultas/Cotacao.json"
import Solicitacao from "../../../../lib/json/consultas/Solicitacao.json"

import ConsultaTotvs from "../../../../backend/ConsultaTotvs";
import { handleCardFornecedor, handleInputCelular, handleInputContato, handleInputEmail, handleInputNome, handleInputTelefone } from "../../../components/GridCell/Fornecedor";
import { format, parse } from "date-fns";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import { ConsultaTotvsEmpresa } from "../../../../backend/ConsultaTotvsEmpresa";
import DisparaEmail from "../../../../backend/DisparaEmail";
import SelectFixo from "../../../components/SelectFixo";
import SelectFinalidade from "../../../components/Select/Finalidade";

function FichaCotacao(){
    const navigate = useNavigate();
    const currentDate = new Date()
    const isFormVisual = window.location.href.includes('Visualizar');
    var usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus
    
    const { idCotacao, empresaFilialCompras } = useParams();
    const { DisparaBootBox, FechaBootBox } = usePopUp();

    const [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);
    const [disabledComprador, setDisabledComprador] = useState(isFormVisual);
    
    const [empresaFilial, setEmpresaFilial] = useState();
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState();
    const [campoNumero, setCampoNumero] = useState();
    const [campoObservacao, setCampoObservacao] = useState();
    const [campoComprador, setCampoComprador] = useState({value: usuarioProtheus?.value || '', label: ''});
    const [campoDataEmissao, setCampoDataEmissao] = useState(format(currentDate, 'yyyy-MM-dd'));
    const [campoDataLimite, setCampoDataLimite] = useState();
    const [campoHoraLimite, setCampoHoraLimite] = useState();
    const [campoEnviaEmail, setCampoEnviaEmail] = useState({value: 'S', text: 'Sim'});
    const [campoTipoCompra, setCampoTipoCompra] = useState({value: '', label: 'Selecione a Finalidade'});
    const [campoAnexos, setCampoAnexos] = useState("");
    
    const [activeTab, setActiveTab] = useState("Solicitacao");
    const [dataSolicitacao, setDataSolicitacao] = useState([]);
    const [dataFornecedor, setDataFornecedor] = useState([]);

    var dataSolicitacaoCompra = []
    var dataFornecedores = []
    
    const columnsFornecedor = [
        {
            Header: 'Nome',
            accessor: "A2_NOME",
            render: handleCardFornecedor
        },
        {
            Header: 'Contato',
            accessor: "CONTATO",
            render: handleInputContato
        },
        {
            Header: 'Nome',
            accessor: "NOME",
            render: handleInputNome
        },
        {
            Header: 'Telefone',
            accessor: "TELEFONE",
            render: handleInputTelefone
        },
        {
            Header: 'Celular',
            accessor: "CELULAR",
            render: handleInputCelular
        },
        {
            Header: 'E-mail',
            accessor: "EMAIL",
            render: handleInputEmail
        },
    ]

    const columnsFilter = [
        {
            Header: 'Item',
            accessor: "C1_ITEM",
        },
        {
            Header: 'CA',
            accessor: "C1_XCA",
        },
        {
            Header: 'Produto/Serviço',
            accessor: "C1_PRODUTO",
        },
        {
            Header: 'Descrição Produto/Serviço',
            accessor: "C1_DESCRI",
        },
        {
            Header: 'Solicitante',
            accessor: "C1_SOLICIT",
        },
        {
            Header: 'CC Desc',
            accessor: "CTT_DESC01",
        },
        {
            Header: 'Prioridade',
            accessor: 'C1_XFLUXSC',
        },
        {
            Header: 'Emissão',
            accessor: 'C1_EMISSAO',
        },
        {
            Header: 'Previsão',
            accessor: 'C1_DATPRF',
        },
        {
            Header: 'Centro Custo',
            accessor: 'C1_CC',
        },
    ];

    const columnsSolicitacao = [
        {
            Header: 'Produto/Serviço',
            accessor: "C1_PRODUTO",
            render: handleProdutoSCCard
        },
        {
            Header: 'Qtde. / Custo Meta',
            accessor: 'C1_QUANT',
            render: handleQtdValorSCCard
        },
        {
            Header: 'Emissão',
            accessor: 'C1_EMISSAO',
            render: handleSCDataEmissaoCard
        },
        {
            Header: 'Centro Custo',
            accessor: 'C1_CC',
            render: handleSCCentroCustoCard
        },
    ];

    const columnsSolicitacaoAditional = [
        {
            Header: 'Descrição Complementar',
            accessor: 'C1_OBS'
        },
        {
            Header: 'Envolvidos',
            accessor: "C1_CODCOMP",
            render: handleCompradorSCColumn
        },
        {
            Header: 'Observação Interna',
            accessor: 'C1_XOBSINT',
            render: handleObservacaoInternaCard
        },
        {
            Header: 'Anexos SC',
            accessor: 'C1_XANXSC',
            render: handleSCAnexosDecode
        },
        {
            Header: 'Anexo Item',
            accessor: 'C1_XANEXO',
            render: handleSCAnexosDecode
        },
    ]

    useEffect( () => {
        const fetchData = async() => {
            if (idCotacao){
                await loadCotacao()
            }
        }

        fetchData()
    }, []);

    const loadCotacao = async() => {
        setCarregar(true);
        
        let cEmpresaFilial = empresaFilialCompras.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilialCompras.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL)
        let consultaDefault = Cotacao.consulta.replace('[CAMPOS]', ', C8_XENVMAI, C8_ITEM, A2_CGC, A2_XTPFORN, A2_MEDIA, A2_MUN, A2_EST, C8_FORNECE, C8_LOJA, C8_FORNOME, C8_XCODCON, C8_CONTATO, C8_FORMAIL, C8_XFORTEL, C8_XFORCEL, C1_NUM, C1_ITEM, CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C8_XOBSCOT))) C8_XOBSCOT, CONVERT(VARCHAR(8000),CONVERT(VARCHAR(8000),CONVERT(VARBINARY(8000),C8_XANXCOT))) C8_XANXCOT');
        consultaDefault += " AND C8_FILIAL = FILIAL(SC8) "
        consultaDefault += " AND C8_NUM = '" + idCotacao + "'"

        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, Cotacao.tabelas, cEmpresaFilial );
            
        if (retConsulta.data){
            let dataFornecedores = retConsulta.data.map( (item) => {
                let dataEmissao = parse(item.C8_EMISSAO, 'yyyyMMdd', new Date());
                let dataLimite  = parse(item.C8_VALIDA, 'yyyyMMdd', new Date());
                    
                dataEmissao = format(dataEmissao, 'yyyy-MM-dd');
                dataLimite = format(dataLimite, 'yyyy-MM-dd');

                setEmpresaFilialSelect(
                    {value: item.EMPRESA + item.C8_FILIAL, text : `${item.EMPRESA + item.C8_FILIAL} - ${item.M0_FILIAL}`}
                )

                setEmpresaFilial(item.EMPRESA + item.C8_FILIAL)

                setCampoNumero(item.C8_NUM)
                setCampoComprador({value: item.Y1_USER, label: item.Y1_COD + " - " + item.Y1_NOME, origem: {Y1_COD: item.Y1_COD, Y1_USER: item.Y1_USER, Y1_NOME: item.Y1_NOME, Y1_EMAIL: item.Y1_EMAIL}})
                setCampoDataEmissao(dataEmissao)
                setCampoDataLimite(dataLimite)
                setCampoHoraLimite(item.C8_XVALIDA)
                setCampoObservacao(item.C8_XOBSCOT)
                setCampoAnexos( JSON.parse( (item.C8_XANXCOT.trim() || "[]") ) )
                setCampoEnviaEmail({value: item.C8_XENVMAI || 'S', text: item.C8_XENVMAI == 'N' ? 'Não' : 'Sim' })

                const fornecedor = {
                    A2_COD: item.C8_FORNECE, 
                    A2_LOJA: item.C8_LOJA,
                    A2_NOME: item.C8_FORNOME,
                    A2_CGC: item.A2_CGC,
                    A2_XTPFORN: item.A2_XTPFORN,
                    A2_MUN: item.A2_MUN,
                    A2_EST: item.A2_EST,
                    A2_MEDIA: item.A2_MEDIA,
                    CONTATO: 
                        {   value: item.C8_XCODCON.trim() || '0', 
                            label: item.C8_CONTATO,
                            origem: 
                                {   
                                    U5_CODCONT: item.C8_XCODCON.trim() || '0', 
                                    U5_CONTAT: item.C8_CONTATO,
                                    U5_EMAIL: item.C8_FORMAIL,
                                    U5_FONE: item.C8_XFORTEL,
                                    U5_CELULAR: item.C8_XFORCEL
                                }
                        },
                    NOME: item.C8_CONTATO,
                    EMAIL: item.C8_FORMAIL,
                    TELEFONE: item.C8_XFORTEL,
                    CELULAR:item.C8_XFORCEL,
                    Check: true,
                    deletado: false,
                    item: item.C8_FORNECE + ' - ' + item.C8_LOJA
                }

                return fornecedor
            })

            const fornecedorUnico = dataFornecedores.filter( (value, index, self) => index === self.findIndex( (t) => t.A2_COD === value.A2_COD && t.A2_LOJA === value.A2_LOJA ) );

            setCarregar(true);
            let consulta = Solicitacao.consulta 
            
            consulta += " AND C1_FILIAL = '" + retConsulta.data[0].C8_FILIAL + "' "

            //Ignorar SC que já está vinculada
            const scVinculada = retConsulta.data.map( (item) => {return item.C1_NUM + item.C1_ITEM}).join("','")

            if (scVinculada){
                consulta += " AND C1_NUM + C1_ITEM IN ('" + scVinculada + "') "
            }

            const retConsultaSC = await ConsultaTotvsEmpresa(consulta, Solicitacao.tabelas, cEmpresaFilial)
            
            if (retConsultaSC.data){
                if (retConsultaSC.data.length > 0){
                    let TipoCompra = ''
                    dataSolicitacaoCompra = retConsultaSC.data.map( (item) => { 
                        TipoCompra = {value: item.C1_TIPCOM, label: item.C1_TIPCOM + " - " + item.DHK_DESCR, origem: { DHK_XPRDIN: item.DHK_XPRDIN, DHK_XPRDFN: item.DHK_XPRDFN, DHK_XDSLA: item.DHK_XDSLA, DHK_XGRPRD: item.DHK_XGRPRD} } 

                        item.Check = true;
                        item.deletado = false;
                        item.item = item.C1_NUM + ' - ' + item.C1_ITEM;
                        item.novoItem = retConsulta.data.filter((itemCot) => itemCot.C1_NUM == item.C1_NUM && itemCot.C1_ITEM == item.C1_ITEM )[0].C8_ITEM;
                        return item 
                    });

                    setCampoTipoCompra(TipoCompra)
                }
            }

            setDataFornecedor(fornecedorUnico)
            setDataSolicitacao(dataSolicitacaoCompra)
        }

        setCarregar(false);
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)

        usuarioLogado = RetornaUsuarioLogado(true, e.value)     
        
        setDisabledComprador(true);
    }

    const handleOrdernarItens = (array) => {
        // 1. Separar os itens
        const codigosNumericos = array.filter(obj => /^\d+$/.test(obj.novoItem));
        const codigosZzzz = array.filter(obj => obj.novoItem === "ZZZZ");

        // 2. Ordenar numericamente
        codigosNumericos.sort((a, b) => parseInt(a.novoItem) - parseInt(b.novoItem));

        // 3. Obter o último número
        let ultimoNumero = codigosNumericos.length
        ? parseInt(codigosNumericos[codigosNumericos.length - 1].novoItem)
        : 0;

        // 4. Substituir "ZZZZ" com valores incrementais
        const novosCodigosZzzz = codigosZzzz.map((item) => {
            ultimoNumero++;
            item.novoItem = String(ultimoNumero).padStart(4, "0")
            return item;
        });

        // 5. Juntar tudo
        const resultadoFinal = [...codigosNumericos, ...novosCodigosZzzz];

        // 2. Ordenar numericamente
        const resultadoFinalOrdenado = resultadoFinal.sort((a, b) => parseInt(a.novoItem) - parseInt(b.novoItem));

        return resultadoFinalOrdenado
    }

    const handleSalvar = async(lEnviarEmail) =>{
        let oRetorno
        setCarregar(true)

        // Função de ordenação dos Itens da SC por "Inclusão na Cotação"
        const dataSolicitacaoAux = handleOrdernarItens(dataSolicitacao);
  
        const aDataSolicitacao = dataSolicitacaoAux.map( (item) => { 
            const solicitacao = {
                NUMERO: item.C1_NUM,
                ITEM: item.C1_ITEM,
                ITEMCOT: item.novoItem,
                DELETAR: item.deletado ? 'true' : 'false' 
            };

            return solicitacao;
        })

        const aDataFornecedor = dataFornecedor.map( (item) => { 
            const fornecedor = {
                FORNECEDOR: item.A2_COD,
                LOJA: item.A2_LOJA,
                NOMEFORNECEDOR: item.A2_NOME,
                CONTATOSU5: item.CONTATO.value || "0",
                CONTATO: item.NOME,
                EMAIL: item.EMAIL,
                TELEFONE: item.TELEFONE,
                CELULAR: item.CELULAR,
                DELETAR: item.deletado ? 'true' : 'false' 
            };

            return fornecedor;
        })

        if (!campoDataLimite){
            toast.warning('O prenchimento do campo Data Limite é obrigatório.');
            setCarregar(false)
            return false;
        }

        if (!campoHoraLimite){
            toast.warning('O prenchimento do campo Hora Limite é obrigatório.');
            setCarregar(false)
            return false;
        }
        
        if (dataSolicitacao && dataSolicitacao.length == 0){
            toast.warning('Obrigatório a seleção de Solicitações de Compra.');
            setCarregar(false)
            return false;   
        }
        
        if (dataFornecedor && dataFornecedor.length == 0){
            toast.warning('Obrigatório a seleção de Fornecedores.');
            setCarregar(false)
            return false;
        }

        const valueJSONOBJ = {
            COTACAO: idCotacao || 0,
            EMISSAO: formatDateComponent(campoDataEmissao),
            VALIDADE: formatDateComponent(campoDataLimite),
            ENVIAEMAIL: campoEnviaEmail.value,
            HORA: campoHoraLimite,
            COMPRADOR: campoComprador.value,
            OBSERVACAO: campoObservacao || '',
            ANEXOS: campoAnexos ? JSON.stringify(campoAnexos) : "",
            FORNECEDOR: aDataFornecedor,
            ITENS: aDataSolicitacao
        };

        // Se você precisa do JSON como string depois (ex: para enviar via API):
        const valueJSON = JSON.stringify(valueJSONOBJ, null, 2);
        
        if (idCotacao){
            oRetorno = await ConsumoTOTVS_POST('ALTERARCOTACAO', valueJSON, empresaFilial)
        }else{
            oRetorno = await ConsumoTOTVS_POST('NOVACOTACAO', valueJSON, empresaFilial)
        }

        setCarregar(false)

        if (oRetorno.error == '00'){
            if (lEnviarEmail){
                if (campoEnviaEmail.value == "S"){
                    DisparaEmailCotacao(oRetorno.data[0].C8_NUM)
                }
            }

            SucessoMsg(oRetorno.description + ' - Cotação Nº ' + oRetorno.data[0].C8_NUM)
        }else{
            ErroMsg(oRetorno.description)
            return false
        }        

        return lEnviarEmail
    }

    const DisparaEmailCotacao = (cCotacao) => {
        const nomeComprador = campoComprador.origem.Y1_NOME;
        const emailComprador = campoComprador.origem.Y1_EMAIL;
        const dataItens = dataSolicitacao.filter((item) => item.deletado == false);
        const dataEnvio = dataFornecedor.filter((item) => item.deletado == false);
    
        let Itens = `<table style="width: 100%; border-collapse: collapse; margin: 20px 0; font-family: Arial, sans-serif;">
            <thead style="background-color: #f4f4f4;">
                <tr>
                    <th style="border: 1px solid #ddd; padding: 10px; text-align: left; font-weight: bold; text-transform: uppercase; letter-spacing: 0.1em;">Produto</th>
                    <th style="border: 1px solid #ddd; padding: 10px; text-align: left; font-weight: bold; text-transform: uppercase; letter-spacing: 0.1em;">Descrição</th>
                    <th style="border: 1px solid #ddd; padding: 10px; text-align: left; font-weight: bold; text-transform: uppercase; letter-spacing: 0.1em;">Quantidade / UM</th>
                    <th style="border: 1px solid #ddd; padding: 10px; text-align: left; font-weight: bold; text-transform: uppercase; letter-spacing: 0.1em;">Data Necessidade</th>
                    <th style="border: 1px solid #ddd; padding: 10px; text-align: left; font-weight: bold; text-transform: uppercase; letter-spacing: 0.1em;">Observação</th>
                </tr>
            </thead>
            <tbody>
        `;
    
        dataItens.forEach((item) => {
            Itens += `
                <tr style="background-color: ${item.C1_OBS ? '#f9f9f9' : '#ffffff'}; transition: background-color 0.3s ease;">
                    <td style="border: 1px solid #ddd; padding: 10px; text-align: left;">${item.C1_PRODUTO}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; text-align: left;">${item.C1_DESCRI}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; text-align: left;">${item.C1_QUANT} ${item.C1_UM}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; text-align: left;">${formatarData(item.NECESSIDADE)}</td>
                    <td style="border: 1px solid #ddd; padding: 10px; text-align: left;">${item.C1_OBS}</td>
                </tr>
            `;
        });
    
        Itens += `</tbody></table>`;
    
        let delay = 0; // Delay inicial
    
        dataEnvio.forEach((item, index) => {
            setTimeout(async () => {
                const nMediaHomologado = window._env_?.REACT_APP_MEDIA_HOMOLOGACAO
                const lHomologado = item.A2_XTPFORN == 'N' || ( item.A2_XTPFORN !== 'N' && item.A2_MEDIA >= nMediaHomologado )
                const secretKey = window._env_?.REACT_APP_KEY_COTACAO

                const dadosCotacao = JSON.stringify({
                    Filial: empresaFilial,
                    Numero: cCotacao,
                    Fornecedor: item.A2_COD,
                    Loja: item.A2_LOJA,
                    Contato: item.NOME,
                    EmailAcesso: item.EMAIL,
                    Homologado: lHomologado
                });

                const encryptedText = encryptAES(dadosCotacao, secretKey);
                const urlEmail = window._env_?.REACT_APP_URL + '/compras/Cotacoes/Fornecedor/' + encryptedText
                const urlhomologacao = window._env_?.REACT_APP_URL + '/compras/Homologacao/Fornecedor/' + encryptedText
                
                let cEmailHomologacao = ''
                
                if (item.A2_XTPFORN !== 'N'){
                    cEmailHomologacao = ( lHomologado ? '' : `<a href="${urlhomologacao}" target="_blank">Clique aqui para realizar a Homologação da sua empresa</a>`)
                }

                const cHtml = `<h2 style="color: #333;">Convite para Participação no Processo de Cotação</h2>
                            <p>Prezado(a) <strong>${item.NOME.trim()}</strong>,</p>
                            <p>É com grande satisfação que convidamos sua empresa, ${item.A2_NOME.trim()}, a participar do processo de cotação atualmente em aberto. Sua contribuição é essencial para garantirmos o melhor atendimento às nossas demandas.</p>
                            <p>As instruções fornecidas nesta Solicitação de Cotação e seus Anexos têm por finalidade orientar a PROPONENTE quanto à forma e condições de apresentação da proposta, fornecendo ainda todas as informações de relevância para a PROPONENTE elaborar sua proposta.</p>
                            <p></p>
                            <p><a href="https://www.npegroup.com.br/portal-do-fornecedor/" style="color: #007BFF;">Portal do Fornecedor.</a></p>
                            <p></p>
                            <h3 style="color: #555; margin-top: 20px;">Abaixo segue lista com o(s) produto(s) a serem cotados:</h3>
                            ${Itens}
                            <p></p>
                            <h3 style="color: #555; margin-top: 20px;">Condições Gerais:</h3>
                            <ul style="padding-left: 20px; margin-top: 10px;">
                                <li>Ao enviar a Proposta Comercial, deverá ser considerado que todo faturamento ocorrerá exclusivamente pelo FORNECEDOR, não sendo permitido o faturamento por terceiros de qualquer item necessário a execução do escopo desta Solicitação de Cotação.</li>
                                <li>Sempre que aplicável, os valores ofertados devem contemplar a inclusão dos seguintes documentos:
                                    <ul style="padding-left: 20px;">
                                        <li>Ficha de Dados de Segurança (FDS), Conforme a ABNT NBR 14725:2023 (não mais aceito a FISPQ).</li>
                                        <li>Certificados de Materiais, Qualidade e Relatórios de Testes Efetuados.</li>
                                        <li>Catálogos e manuais dos produtos.</li>
                                    </ul>
                                </li>
                                <li>Em atendimento ao item 8.4 das normas ISO 9001 / 45001, a NPE informa que os critérios de qualificação e avaliação de fornecedor, se encontra disponibilizado no site: <a href="https://www.npegroup.com.br/wp-content/uploads/2024/09/CRITERIOS-DE-QUALIFICACAO-E-AVALIACAO-DE-FORNECEDORES-NPE-1.pdf" style="color: #007BFF;">Critérios de Homologação e Avaliação de Fornecedores NPE</a>.</li>
                                <li>As Partes se obrigam a cumprir rigorosamente os ditames da Lei nº 13.709/2018 ’ Lei Geral de Proteção de Dados ’ LGPD, se comprometendo a prestarem assistência mútua com suas obrigações, no limite de suas atribuições e responsabilidades, notadamente no que se refere ao dever de cautela e salvaguarda necessária para proteção dos dados.</li>
                                <li>O <strong>FORNECEDOR</strong> se compromete a agir com ética e transparência, obedecendo ao disposto no Código de Ética e Conduta de Fornecedor da NPE, disponibilizado no site <a href="https://www.npegroup.com.br/wp-content/uploads/2024/01/Codigo-de-etica-e-conduta-de-fornecedores_NPE.pdf" style="color: #007BFF;">Código de Ética e Conduta de Fornecedores</a>, sob pena de reparação por perdas e danos.</li>
                            </ul>
                            <p>Pedimos que envie sua proposta dentro do prazo estipulado para garantir a inclusão no processo de análise. Caso tenha dúvidas ou necessite de informações adicionais, nossa equipe está à disposição para auxiliá-lo.</p>
                            <p><strong>Data Limite:</strong>${formatarData(formatDateComponent(campoDataLimite))} - ${campoHoraLimite}<p>
                            <p></p>
                            ${cEmailHomologacao}
                            <a href="${urlEmail}" target="_blank">Clique aqui para acessar e enviar sua proposta</a>
                            <p></p>
                            <p>Agradecemos desde já pelo interesse e pela colaboração.</p>
                            <p></p>
                            <span><strong>Qualquer dúvida, sugestões ou problemas, favor acionar o responsável:</strong></span>
                            <span>${nomeComprador.trim()} - ${emailComprador.trim()}</span>`
    
                const dadosEnvio = {
                    destinatario: item.EMAIL,
                    assunto: "Solicitação de Cotação - Processo nº " + cCotacao,
                    corpo: cHtml,
                    sender: usuarioLogado.email,
                };
    
                await DisparaEmail(dadosEnvio);
            }, delay);
    
            delay += 5000; // Aumenta o intervalo para o próximo envio (5 segundos)
        });

        SucessoMsg("E-mail de Cotação Enviado com Sucesso!")
    };

    const handleAddFiles = async(acceptedFiles, fileRejections, event) => {
        const allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'application/pdf',
            'application/msword',
            'text/plain',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', // .xls
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
            'text/csv' // .csv
        ];

        const isValidFileType = acceptedFiles.every(file => allowedFileTypes.includes(file.type));

        if (!isValidFileType) {
            toast.warning('Tipos de arquivo não permitidos. Faça o upload apenas de imagens (jpeg, png), PDF, DOC ou arquivos de texto.');
            return;
        }

        const retUpload = await ConsumoAPI_FileUpload(acceptedFiles);
        
        if (event){
            event.persist()
            event.preventDefault()
        }

        if (retUpload.error === "00") {
            const newFiles = retUpload.data.map(file => file);
            const filesUpload = [...campoAnexos, ...newFiles]
            setCampoAnexos(filesUpload)

            return filesUpload;
        }
    }

    const handleDelFiles = (fileDelete) => {
        const updatedFiles = [...campoAnexos];
        updatedFiles.splice(fileDelete, 1);

        setCampoAnexos(updatedFiles)
        return updatedFiles;
    }

    const handleExcluirSolicitacao = async (row) => {
        const idRow = row.item;

        setDataSolicitacao((prevData) => 
            prevData.map((Solicitacao) => {
                if (Solicitacao.item === idRow){
                    return { ...Solicitacao, deletado: true };
                }else{
                    return Solicitacao;
                } 
            })
        );
    }
    
    const handleExcluirFornecedor = async (row) => {
        const idRow = row.item;

        setDataFornecedor((prevData) => 
            prevData.map((fornecedor) => {
                if (fornecedor.item === idRow){
                    return { ...fornecedor, deletado: true };
                }else{
                    return fornecedor;
                } 
            })
        );
    }

    const handleGeraLink = (row) => {
        const secretKey = window._env_?.REACT_APP_KEY_COTACAO
        const dadosCotacao = JSON.stringify({
            Filial: empresaFilial,
            Numero: campoNumero,
            Fornecedor: row.original.A2_COD,
            Loja: row.original.A2_LOJA,
            Contato: row.original.NOME,
            EmailAcesso: row.original.EMAIL,
            Homologado: true
        });

        const encryptedText = encryptAES(dadosCotacao, secretKey);
        const urlEmail = window._env_?.REACT_APP_URL + '/compras/Cotacoes/Fornecedor/' + encryptedText

        const Mensagem = (
            <Row>
                <Col md={10}>
                    <InputGeral
                        tipo={'text'}
                        value={urlEmail}
                        disabled={true}
                    />
                </Col>
                <Col md={2}>
                    <Button
                        variant="primary"
                        onClick={() => {
                        navigator.clipboard.writeText(urlEmail);
                        toast.success("Copiado com Sucesso");
                        }}
                        style={{ marginLeft: "8px" }}
                    >Copiar URL</Button>
                </Col>
            </Row>
        );
	
		const buttonsRender = [
			{ variant: 'primary', action: FechaBootBox, label: 'Fechar' }
		];
	
		DisparaBootBox('Link Acesso Fornecedor', Mensagem, buttonsRender, 0, FechaBootBox, 'xl', false);
    }

    const btnIncluirSolicitacao = async() => {
        setCarregar(true);
        const parametroEmpresa = usuarioLogado.filtraParametroEmpresasCentroCusto
        let cEmpresaFilial = empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL)
        let consulta = Solicitacao.consulta + " AND C1_EMISSAO >= '20250101' AND " + optionsStatusSC[1].filtroSQL
        
        //Ignorar SC que já está vinculada
        const scVinculada = dataSolicitacao.map( (item) => {return item.C1_NUM + item.C1_ITEM}).join("','")

        consulta += " AND C1_FILIAL = '" + empresaFilial.substring(2,8) + "' "

        if (scVinculada){
            consulta += " AND C1_NUM + C1_ITEM NOT IN ('" + scVinculada + "') "
        }

        if (parametroEmpresa.centroCusto.length > 0){
            consulta += " AND C1_CC IN ('" + parametroEmpresa.centroCusto.join("','") + "')"
        }

        consulta += " AND C1_TIPCOM = '" + campoTipoCompra.value + "' "

        if (campoComprador.value){
            consulta += " ORDER BY IIF(Y1_USER = '" + campoComprador.value + "', 1, 2) ASC, NECESSIDADE ASC" //+ Data Previsao Mais proxima
        }

        const retConsulta = await ConsultaTotvsEmpresa(consulta, Solicitacao.tabelas, cEmpresaFilial)
        
        if (retConsulta.data){
            if (retConsulta.data.length > 0){
                dataSolicitacaoCompra = retConsulta.data.map( (item) => { item.Check = false; return item });
            }
        }

        setCarregar(false);
        SelecaoSolicitacaoCompra( DisparaBootBox, FechaSelecaoSC, dataSolicitacaoCompra, FechaBootBox);
    }

    const FechaSelecaoSC = () => {
        let scSelecionada = dataSolicitacaoCompra.filter( (item) => item.Check == true)
        
        scSelecionada.map( (itemMap) => { 
            itemMap.deletado = false;
            itemMap.item = itemMap.C1_NUM + ' - ' + itemMap.C1_ITEM;
            itemMap.show = true;
            itemMap.novoItem = 'ZZZZ';
        });

        const newDataSC = [...dataSolicitacao, ...scSelecionada];

        setDataSolicitacao(newDataSC)
        FechaBootBox()
    }

    const btnIncluirFornecedor = async() => {
        setCarregar(true);
        
        let cEmpresaFilial = empresaFilial.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresaFilial.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL)
        let dataParametro = new Date();
        const produtos = dataSolicitacao.map( (item) => {return item.C1_PRODUTO}).join("','")
        
        dataParametro.setDate(dataParametro.getDate() - window._env_?.REACT_APP_COTACAO_PERIODO_COMPRAS);

        let consulta = "SELECT A2_COD, A2_LOJA, A2_NOME, A2_CGC, A2_XTPFORN, A2_MEDIA, A2_MUN, A2_EST, '' CONTATO, '' NOME, '' EMAIL, '' TELEFONE, '' CELULAR, SUM(C7_TOTAL) TOTAL FROM TABELA(SA2) SA2 "
        consulta += "LEFT JOIN TABELA(SC7) SC7 ON C7_PRODUTO IN ('" + produtos + "') AND C7_EMISSAO >= '" + format(dataParametro, "yyyyMMdd") + "' AND C7_FORNECE = A2_COD AND C7_LOJA = A2_LOJA AND SC7.D_E_L_E_T_ <> '*' "
        consulta += "WHERE SA2.D_E_L_E_T_ <> '*' AND A2_MSBLQL != 1 "

        //Ignorar Fornecedor que já está vinculado
        const fornecedorVinculada = dataFornecedor.map( (item) => {return item.A2_COD + item.A2_LOJA}).join("','")

        if (fornecedorVinculada){
            consulta += " AND A2_COD + A2_LOJA NOT IN ('" + fornecedorVinculada + "') "
        }

        //Verificar Produtos e Grupo SC para Ordenar Fornecedores
        consulta += "GROUP BY A2_COD, A2_LOJA, A2_NOME, A2_CGC, A2_XTPFORN, A2_MEDIA, A2_MUN, A2_EST "
        consulta += "ORDER BY TOTAL DESC "

        const retConsulta = await ConsultaTotvsEmpresa(consulta, 'SA2;SC7', cEmpresaFilial)
        
        if (retConsulta.data){
            if (retConsulta.data.length > 0){
                dataFornecedores = retConsulta.data.map( (item) => { item.Check = false; return item });;
            }
        }

        setCarregar(false);
        SelecaoFornecedores( DisparaBootBox, FechaSelecaoFornecedor, dataFornecedores);
    }

    const FechaSelecaoFornecedor = () => {
        let fornecedoresselecionado = dataFornecedores.filter( (item) => item.Check == true)
        
        fornecedoresselecionado.map( (itemMap) => { 
            itemMap.deletado = false;
            itemMap.item = itemMap.A2_COD + ' - ' + itemMap.A2_LOJA;
        });

        const newDataFornecedor = [...dataFornecedor, ...fornecedoresselecionado];

        setDataFornecedor(newDataFornecedor)
        FechaBootBox()  
    }

    const handleAlterData = (data) => {
        setDataFornecedor(data)
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="Cotação" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial && (
                <>
                    <Row>
                        <Col md="10" xs="12">
                            <h5>Dados da Cotação: </h5>
                        </Col>
                    </Row>
                    <Row>

                    { campoNumero && 
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Numero"
                                placeholder="Numero"
                                tipo="text"
                                value={campoNumero}
                                onChange={(e) => setCampoNumero(e)}
                                disabled={disabledForm}
                            />
                        </Col>
                    }
                        <Col md="4" xs="12">
                            <SelectComprador
                                campoComprador={campoComprador}
                                changeComprador={setCampoComprador}
                                empresaLogada={empresaFilial}
                                disabled={false}
                                returnOriginal={true}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Data Emissão"
                                tipo='date'
                                value={campoDataEmissao}  // Use detail.cargo instead of campoEmail
                                onChange={(e) => setCampoDataEmissao(e.target.value)}
                                disabled={true}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral
                                label="Data Limite"
                                tipo='date'
                                value={campoDataLimite}  // Use detail.cargo instead of campoEmail
                                onChange={(e) => setCampoDataLimite(e.target.value)}
                                min={format(currentDate, 'yyyy-MM-dd')}
                                disabled={disabledForm}
                            />
                        </Col>
                        <Col md="2" xs="12">
                            <InputGeral 
                                label="Hora Limite: " 
                                tipo='hora'
                                value={campoHoraLimite}  // Define o valor do campo com base no estado
                                onChange={(e) => setCampoHoraLimite(e.target.value)}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="2" xs="12">
                            <SelectFixo
                                options={[{value:'S', text:'Sim'},{value:'N', text:'Não'}]} 
                                value={campoEnviaEmail} 
                                selectedOptionValue={campoEnviaEmail} 
                                isLabel={true} 
                                label="Enviar E-mail" 
                                onChange={(e) => setCampoEnviaEmail(e)}
                            />
                        </Col>
                        <Col md="3" xs="12">
                            <SelectFinalidade
                                campoFinalidade={campoTipoCompra}
                                changeFinalidade={setCampoTipoCompra}
                                empresaLogada={empresaFilial}
                                returnOriginal={true}
                                disabled={disabledForm}
                                filtraFilial={true}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <InputGeral
                                tipo={"textArea"}
                                label={"Observação Cotação - Apresentado a Todos Fornecedores"}
                                onChange={(e) => setCampoObservacao(e.target.value)}
                                value={campoObservacao}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12" xs="12">
                            <LabelInput>Anexos</LabelInput>
                            <UploadFiles 
                                onDropEvent={handleAddFiles}
                                onDeleteEvent={handleDelFiles}
                                value={campoAnexos}
                                disabled={disabledForm}
                            />
                        </Col>
                    </Row>
                    <Tabs activeKey={activeTab} onSelect={(index) => setActiveTab(index)} id="tab-panel">
                        <Tab key={"Solicitacao"} eventKey={"Solicitacao"} title={"Solicitação de Compra"}>
                            { !disabledForm && (
                                <Row className="d-flex align-content-end align-items-end justify-content-end">
                                    <Col md='4' xs="12">
                                        { campoTipoCompra.value.trim() && (
                                            <Button variant="outline-info" onClick={btnIncluirSolicitacao} className="w-100">
                                                ✶ Adicionar SC
                                            </Button>
                                        )}
                                    </Col>
                                </Row>
                            )}

                            <TrelloBoard 
                                columns={columnsSolicitacao} 
                                columnsFilter={columnsFilter} 
                                columnsAditional={columnsSolicitacaoAditional}
                                data={dataSolicitacao.filter((item) => item.deletado == false)} 
                                titleLista="SC: "
                                buttons= { disabledForm ? [] : 
                                        [   
                                            {action: handleExcluirSolicitacao, label: "Excluir", icone: "MdPlaylistRemove", style: "outline-danger", regraExclude: '(row.original.C1_PEDIDO.trim() != "")' }
                                        ]
                                }
                                tamanhoCard="65lvh"
                                setData={setDataSolicitacao}
                                HabilitaBuscar={true}
                                AbreBox={DisparaBootBox}
                                FechaBox={FechaBootBox}
                            />
                        </Tab>
                        <Tab key={"Fornecedores"} eventKey={"Fornecedores"} title={"Fornecedores"}>
                            { !disabledForm && (
                                <Row className="d-flex align-content-end align-items-end justify-content-end">
                                    <Col md='4' xs="12">
                                        <Button variant="outline-info" onClick={btnIncluirFornecedor} className="w-100">
                                            ✶ Adicionar Fornecedor
                                        </Button>
                                    </Col>
                                </Row>
                            )}
                            <TrelloBoard 
                                columns={columnsFornecedor} 
                                data={dataFornecedor.filter((item) => item.deletado == false)} 
                                titleLista="Fornecedor: "
                                setData={handleAlterData}
                                disabledForm={disabledForm}
                                buttons= { disabledForm ? 
                                                campoNumero ? [
                                                    {action: handleGeraLink, label: "Link Cotação", icone: "MdOutlineLink", style: "outline-primary" }
                                                ] : []
                                        : [   
                                            {action: handleGeraLink, label: "Link Cotação", icone: "MdOutlineLink", style: "outline-primary" },
                                            {action: handleExcluirFornecedor, label: "Excluir", icone: "MdPlaylistRemove", style: "outline-danger" }
                                        ]
                                }
                                tamanhoCard="80lvh"
                            />
                        </Tab>
                    </Tabs>
                </>
            )}
            
            <SubmitForm 
                labelEnviar={"➤ Salvar & Enviar"}
                onSave={ disabledForm ? null : async() => { return await handleSalvar(false)} }
                onEnviar={ disabledForm ? null : async() => { return await handleSalvar(true)} }
                onCancel={ disabledForm ? null : 'handleVoltar'}
                onVoltar={ disabledForm ? 'handleVoltar' : null}
            />
            
        </>
    );
}

export default FichaCotacao;